const authClientId = process.env.AUTH0_CLIENT_ID || 'k9bxpwocNSGwZZUWAoWuJGqhtg9saxUG';
const tenantId = process.env.AUTH0_CLIENT_ID || 'cse';

export {
    authClientId,
    tenantId,
};



// WEBPACK FOOTER //
// ./src/settings.js